// document.addEventListener("DOMContentLoaded", function() {
//   var navItems = document.querySelectorAll('.main-menu li[data-menu-id]');

//   navItems.forEach(function(navItem) {
//       navItem.addEventListener('mouseenter', function() {
//           var menuId = navItem.getAttribute('data-menu-id');
//           var submenu = document.querySelector('.submenu[data-submenu-id="' + menuId + '"]');
//           if (submenu) {
//               submenu.style.display = 'block';
//           }
//       });

//       navItem.addEventListener('mouseleave', function() {
//           var menuId = navItem.getAttribute('data-menu-id');
//           var submenu = document.querySelector('.submenu[data-submenu-id="' + menuId + '"]');
//           if (submenu) {
//               submenu.style.display = 'none';
//           }
//       });
//   });
// });


// sticky insert
// will move the custom nav into the site header so it scrolls with the header
// document.addEventListener('DOMContentLoaded', function() {
//   var customNavParent = document.querySelector('.damon-custom-nav').parentElement;
//   var siteHeader = document.querySelector('.site-header');

//   if (siteHeader && customNavParent) {
//       siteHeader.appendChild(customNavParent);
//   }
// });

// less desctructive way to sticky - apply styles dynamically instead of manipulating the DOM 
document.addEventListener('DOMContentLoaded', function() {
  var damonCustomNavParent = document.querySelector('.damon-custom-nav').parentElement;

  // add classname to damonCustomNavParent
  damonCustomNavParent.classList.add("damon-custom-nav-parent");

  // if (damonCustomNavParent) {
  //     damonCustomNavParent.style.position = 'sticky';
  //     damonCustomNavParent.style.top = '88px';
  //     damonCustomNavParent.style.zIndex = 3;
  // }
});





document.addEventListener('DOMContentLoaded', function () {
  const mainMenuItems = document.querySelectorAll('.main-menu li[data-menu-id]');
  const allSubmenus = document.querySelectorAll('.all-submenus .submenu');
  let leaveTimeout;

  mainMenuItems.forEach((item) => {
    item.addEventListener('mouseenter', function () {
      const menuId = item.getAttribute('data-menu-id');
      const correspondingSubmenu = document.querySelector(`.submenu[data-submenu-id="${menuId}"]`);


      // Hide all other submenus and remove underline from all menu items
      allSubmenus.forEach((submenu) => (submenu.style.display = 'none'));
      mainMenuItems.forEach((menuItem) => menuItem.classList.remove('underline'));

      if (correspondingSubmenu) {
        // let itemRect = item.getBoundingClientRect(); // Get the bounding rectangle of the hovered item
        // correspondingSubmenu.style.top = itemRect.bottom + 'px';
        // const isPosition2 = document.querySelector('html').classList.contains('sticky-header-hide'); // Replace 'position-2-class' with the actual class name or data attribute you're using
        // correspondingSubmenu.style.top = isPosition2 ? '-92px' : '0';

        correspondingSubmenu.style.display = 'grid';
        item.classList.add('underline'); // Add underline class to the hovered menu item
      }

      // Clear any timeout if moving between menu items quickly
      clearTimeout(leaveTimeout);
    });

    item.addEventListener('mouseleave', function () {
      const menuId = item.getAttribute('data-menu-id');
      const correspondingSubmenu = document.querySelector(`.submenu[data-submenu-id="${menuId}"]`);

      // Set a timeout to hide the submenu after a short delay
      leaveTimeout = setTimeout(() => {
        if (correspondingSubmenu) {
          correspondingSubmenu.style.display = 'none';
          item.classList.remove('underline'); // Remove underline class when submenu is hidden
        }
      }, 100); // 100ms delay, adjust as necessary
    });
  });

  allSubmenus.forEach((submenu) => {
    submenu.addEventListener('mouseenter', function () {
      // Clear the timeout if mouse enters the submenu
      clearTimeout(leaveTimeout);
    });

    submenu.addEventListener('mouseleave', function () {
      // Hide submenu when the mouse leaves it
      submenu.style.display = 'none';
      // Find the parent menu item for this submenu
      const parentMenuItem = Array.from(mainMenuItems).find(item => item.getAttribute('data-menu-id') === submenu.getAttribute('data-submenu-id'));
      if (parentMenuItem) {
        parentMenuItem.classList.remove('underline'); // Remove underline class from the parent menu item
      }
    });
  });
});



// mobile
const hamburger = document.getElementById('customHamburger');
const drawer = document.getElementById('customDrawer');
const mainMenu = document.getElementById('mobileMainMenu');
const subMenus = document.querySelectorAll('.mobile-submenu');
const closeIcon = document.getElementById('closeDrawer');

hamburger.addEventListener('click', function() {
    if (drawer.classList.contains('show')) {
        drawer.classList.remove('show');
        document.body.classList.remove('drawer-open');
        mainMenu.style.transform = 'translateX(0)';
        subMenus.forEach(sub => {
            sub.style.transform = 'translateX(100%)';
        });
    } else {
        drawer.classList.add('show');
        document.body.classList.add('drawer-open');
    }
});

document.addEventListener('click', function(event) {
    // If the drawer is open AND the clicked target is neither the drawer nor the hamburger
    if (document.body.classList.contains('drawer-open') && !drawer.contains(event.target) && !hamburger.contains(event.target)) {
      drawer.classList.remove('show');
      document.body.classList.remove('drawer-open');
      mainMenu.style.transform = 'translateX(0)';
      subMenus.forEach(sub => {
          sub.style.transform = 'translateX(100%)';
      });
      return;  // Exit early after closing drawer
  }

    const clickedElement = event.target.closest('li[data-menu-id]');
    if (clickedElement) {
        const parentLi = clickedElement.closest('li');
        const submenu = document.querySelector(`[data-submenu-id="${parentLi.dataset.menuId}"]`);
        
        mainMenu.style.transform = 'translateX(-100%)';
        submenu.style.transform = 'translateX(-100%)';
        // event.preventDefault();
    }

    if (event.target.closest('.back-button')) {
        mainMenu.style.transform = 'translateX(0)';
        subMenus.forEach(sub => {
            sub.style.transform = 'translateX(100%)';
        });
        event.preventDefault();
    }

    // x
    if (event.target === closeIcon || event.target.parentElement === closeIcon) {
      drawer.classList.remove('show');
      document.body.classList.remove('drawer-open');
      mainMenu.style.transform = 'translateX(0)';
      subMenus.forEach(sub => {
          sub.style.transform = 'translateX(100%)';
      });
  }
});

